import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider, useAppContext } from './context/AppContext';
import { ThemeProvider } from './context/ThemeContext';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import Trader from './pages/Trader';
import Depositor from './pages/Depositor';
import TraderDetailPage from './pages/TraderDetailPage';
import DepositorDetailPage from './pages/DepositorDetailPage';
import Profile from './pages/Profile';
import { LoadingSpinner } from './components/LoadingSpinner';
import Subnets from './pages/Subnets';
import SubnetDetailPage from './pages/SubnetDetailPage';
import Home from './pages/Home';
import { JoinWaitlistModalProvider } from './context/ModalContext';
import ProtectedRoute from './components/ProtectedRoute';
import { EVMProvider } from './context/EVMContext';

const AppContent: React.FC = () => {
  const { isLoading } = useAppContext();

  return (
    <Router>
      <JoinWaitlistModalProvider>
        <div className="min-h-screen bg-white dark:bg-black transition-colors duration-300">
          <Header />
          <main className="transition-colors duration-300 pb-8">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/trader" element={<ProtectedRoute><Trader /></ProtectedRoute>} />
              <Route path="/trader/:id" element={<ProtectedRoute><TraderDetailPage /></ProtectedRoute>} />
              <Route path="/depositor" element={<ProtectedRoute><Depositor /></ProtectedRoute>} />
              <Route path="/depositor/:id" element={<ProtectedRoute><DepositorDetailPage /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/subnets" element={<ProtectedRoute><Subnets /></ProtectedRoute>} />
              <Route path="/subnet/:id" element={<ProtectedRoute><SubnetDetailPage /></ProtectedRoute>} />
            </Routes>
          </main>
          <LoadingSpinner isLoading={isLoading} />
        </div>
      </JoinWaitlistModalProvider>
    </Router>
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AppProvider>
        <EVMProvider>
          <AppContent />
        </EVMProvider>
      </AppProvider>
    </ThemeProvider>
  );
};

export default App;
